import Navigation from "../../components/Navigation/Navigation";
import SecondaryNavigation from "../../components/SecondaryNavigation/SecondaryNavigation"
import Table from "../../components/Table/Table";
import { useState, useEffect, useContext } from "react";
import { context, } from '../../context/authContext';
import useApi from '../../helpers/api';
import Loader from "../../components/Loader/Loader";

const columns=[
  { field: "id", sort: "desc"},
  { field: "api" },
  { field: "usuario" },
  { field: "code" },
  { field: "detalle", flex: 10 },
  { field: "createdAt", valueFormatter: item => {
    let date =  `${new Date(item.value).toLocaleDateString("en-GB")} 
          ${new Date(item.value).toLocaleTimeString("en-GB")}` 
        return date;
    }, flex: 3
  } 
]


export default function Logs() {
  const [data, setData] = useState(null);
  const { token } = useContext(context);
  const { handleLogout } = useContext(context);
  const api = useApi();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.logs();
        if (!!response.response) {
          if(!!response.response.data.error){
            handleLogout();
          }
        }
        setData(response)
      } catch (err) {
        console.log(err)
        handleLogout();
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleLogout, token]);

  return (
    <>
      <Navigation />
      <SecondaryNavigation title="Logs" />
      {!!data ?
        <Table columns={columns} data={data} />
      :
        <Loader/>
      }
    </>
  );
}